export default class ContactForm {
    constructor() {
        this.formCheckboxes = [
            ...document.querySelectorAll(
                ".contact__form .-rules input[type=checkbox]"
            ),
        ];

        this.newsletterAcceptance = document.querySelector(
            ".acceptance-newsletter-rodo"
        );

        this.events();
    }

    events() {
        if (this.formCheckboxes.length) {
            this.formCheckboxes.forEach((checkbox) =>
                checkbox.addEventListener(
                    "change",
                    this.toggleCssClass.bind(this)
                )
            );
        }
    }

    toggleCssClass(ev) {
        const clickedCheckbox = ev.currentTarget;

        if (!clickedCheckbox) return;
        const parentWrapper = clickedCheckbox.closest(".-rules");

        if (!parentWrapper) return;
        if (clickedCheckbox.checked) {
            parentWrapper.classList.add("checked");

            if (clickedCheckbox.classList.contains("acceptance-newsletter"))
                this.newsletterAcceptance.style.display = "block";
        } else {
            parentWrapper.classList.remove("checked");

            if (clickedCheckbox.classList.contains("acceptance-newsletter"))
                this.newsletterAcceptance.style.display = "none";
        }
    }
}
